export interface Testimonial {
  name: string;
  title: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: '张明远',
    title: '文化评论家',
    content: '在信息泛滥的时代，精品久久久像一泓清泉。每一篇文章都经过精心打磨，每一次阅读都是一次心灵的沉淀。这是我每天必读的平台，也是我向朋友推荐最多的内容来源。',
    rating: 5,
  },
  {
    name: '李婉清',
    title: '大学教师',
    content: '作为教育工作者，我一直在寻找能够推荐给学生的优质阅读材料。精品久久久的文章深度与广度兼具，既能拓展视野，又能启发思考。我的学生们都很喜欢这里的深度阅读栏目。',
    rating: 5,
  },
  {
    name: '王浩然',
    title: '互联网创业者',
    content: '精品久久久让我在繁忙的创业生活中找到了精神栖息地。科技前沿栏目的文章尤其精彩，既有专业深度，又不失可读性。每次阅读都能获得新的灵感和思考角度。',
    rating: 5,
  },
  {
    name: '陈美琪',
    title: '自由设计师',
    content: '艺术设计和生活美学是我最喜欢的两个板块。精品久久久的内容总是能给我带来设计灵感，而且文章的配图和排版都非常讲究，阅读体验本身就很享受。',
    rating: 5,
  },
  {
    name: '刘建国',
    title: '退休医师',
    content: '退休后，精品久久久成为了我每天的精神食粮。健康养生专栏非常专业，不是那种市面上常见的养生谣言，而是真正有科学依据的内容。人物专栏也让我看到了很多精彩的人生故事。',
    rating: 5,
  },
  {
    name: '赵思涵',
    title: '研究生',
    content: '作为研究生，精品久久久帮助我突破了专业领域的局限。这里的跨学科内容让我看到了更广阔的知识视野，对我的学术研究也很有启发。强烈推荐给每一位求知者。',
    rating: 5,
  },
];